"use strict";"function"==typeof SuppressedError&&SuppressedError,exports.__awaiter=function(n,t,e,r){return new(e||(e=Promise))((function(o,c){function u(n){try{a(r.next(n))}catch(n){c(n)}}function i(n){try{a(r.throw(n))}catch(n){c(n)}}function a(n){var t;n.done?o(n.value):(t=n.value,t instanceof e?t:new e((function(n){n(t)}))).then(u,i)}a((r=r.apply(n,t||[])).next())}))};



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/calendars/~/@vds-core/utilities/cjs/_virtual/_tslib.js
// module id = 888
// module chunks = 0